<template>
  <div data-sidebar="header" class="flex flex-col overflow-visible">
    <slot />
  </div>
</template>
